import { FiltersLayoutProvider } from '@/catalog-apps/components/AppPage2'
import { SupportPanelView } from '@/catalog-apps/components/AppSupportMenu'
import { MAIN_CONTENT_HEIGHT, MAIN_CONTENT_WIDTH } from '@/catalog-apps/components/config'
import { motion } from 'motion/react'
import { PageBuilderPage } from './PageBuilderPage'

export type SupportPanelState = {
  supportPanelView?: SupportPanelView
  setSupportPanelView: React.Dispatch<React.SetStateAction<SupportPanelView | undefined>>
}

export function AppPageBuilderPage() {
  return (
    <motion.div layout style={{ width: MAIN_CONTENT_WIDTH, height: MAIN_CONTENT_HEIGHT }}>
      <FiltersLayoutProvider>
        <div className="flex h-full w-full">
          <PageBuilderPage />
        </div>
      </FiltersLayoutProvider>
    </motion.div>
  )
}
